/* @flow */

import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom'
import { } from 'src/constants/actionTypes';

// import SpinnerAndToast, { showMessage } from './SpinnerAndToast';
import { useIntl } from 'react-intl';
import GlobalDndContext from '../../components/DndContext';
import MdEditorFull from '../../components/markdown-editor/MdEditorFull';
import AIModal from '../../components/ai/AIModal';
import ConfirmDialog from '../../components/ConfirmDialog';
import ReactGA from "react-ga4";
import { getAppConfig, getUserInfo, getServingPrivilege } from '@/actions/ticketAction';
import { AI_SETTINGS, APP_CONFIG, FLOW_MODAL } from '../../constants/actionTypes';
import SettingsModal from '../../components/SettingsModal';
import { PromptModal } from '../../components/settings/PromptModal';
import PromptsModal from '@/components/settings/PromptsModal';
import { ImageUploadModal } from '../../components/common/ImageUploadModal';
import InfoModal from '@/components/flow/Modal';
import InviteFriendsModal from '../../components/feedbacks/InviteFriendsModal';
import { isElectronApp } from 'src/utils/constants';

const MarkdownEditor = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const location = useLocation();
  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  const aiSettings = useSelector(state => state.uiState.aiSettings) || {};
  const actionModalState = useSelector(state => state.uiState.flow_modal);

  useEffect(() => {
    // ReactGA.initialize(GOOGLE_ANALYTICS_TRACKID);
    ReactGA.send({ hitType: "pageview", page: "/markdown", title: "Markdown Editor" });
  }, [])

  useEffect(() => {
    // dispatch(getUserInfo());
    dispatch(getAppConfig({ service: 'markdown_editor' }, (data) => {
      dispatch({
        type: APP_CONFIG,
        value: data
      })
    }));

    // dispatch(getLngSetting({}));

    // dispatch(getServingPrivilege({ privilege: 'usePrivateAIApi' }, (privileged) => {
    //   if (!privileged) {
    //     dispatch({
    //       type: AI_SETTINGS,
    //       value: {
    //         ...aiSettings,
    //         aiProvider: 'funblocks'
    //       }
    //     })
    //   }
    // }))

  }, [dispatch]);

  useEffect(() => {
    if (actionModalState?.visible || !actionModalState?.action_confirmed) return;

    if (actionModalState.action_confirmed === 'login') {
      const url = '/#/login?source=markdown&to=markdown';

      if (isElectronApp()) {
        window.electronAPI.openLoginWindow(url);
      } else {
        window.open(url, '_blank');
      }
    } else if (actionModalState.action_confirmed === 'saved_to_workspace' && actionModalState.data?.hid) {
  window.open(`/#/${actionModalState.data.viewer || 'editor'}?hid=${actionModalState.data?.hid}`, '_blank');
}

dispatch({
  type: FLOW_MODAL,
  value: {
    visible: false
  }
})
  }, [actionModalState])

useEffect(() => {
  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      dispatch(getUserInfo());
    }
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);

  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
}, []);

return (
  <GlobalDndContext>
    <MdEditorFull embedded={params.embedded} />

    <AIModal />
    <InfoModal />
    <ConfirmDialog />
    <SettingsModal />
    <ImageUploadModal />
    <PromptModal />
    <PromptsModal />
    <InviteFriendsModal />
  </GlobalDndContext>
)
}

export default MarkdownEditor;
